import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedAbsences } from '@/connectors'

export const AbsencesPage: FC = (): ReactElement => (
    <Page className="absences-page">
        <ConnectedAbsences />
    </Page>
)
